import { render, staticRenderFns } from "./AvatarEditor.vue?vue&type=template&id=907cd8ea&scoped=true&"
import script from "./AvatarEditor.vue?vue&type=script&lang=js&"
export * from "./AvatarEditor.vue?vue&type=script&lang=js&"
import style0 from "./AvatarEditor.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AvatarEditor.vue?vue&type=style&index=1&id=907cd8ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907cd8ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAvatar,VBtn,VFileInput,VIcon,VProgressCircular})
